/**
 * Branding-Modul-Cache (synchron lesbar fuer Nicht-React-Utils wie PDF-Generatoren).
 *
 * Wird vom BrandingContext beim Laden/Aktualisieren via setBranding() befuellt.
 * pdfLayout.js / analyticsReportHelpers.js lesen das aktive Logo + Firmennamen
 * synchron beim PDF-Erzeugen ueber getBranding().
 */

export const DEFAULT_COMPANY_NAME = 'QM8D.ai';

// Leeres PDF-Theme = jede Engine nutzt ihren heutigen Default (keine Regression).
export const PDF_THEME_SLOTS = ['accent', 'header_bg', 'table_header', 'text', 'footer_bg', 'watermark'];
// Stufe b/c: Header/Footer-Gestaltung (Hintergrund/Bild) + Masse innerhalb A4.
export const PDF_THEME_LAYOUT_KEYS = [
  'header_height_mm', 'header_full_width', 'header_image', 'header_fit',
  'footer_height_mm', 'footer_full_width', 'footer_image', 'footer_fit',
];

function emptyPdfTheme() {
  const t = {};
  PDF_THEME_SLOTS.forEach((s) => { t[s] = ''; });
  PDF_THEME_LAYOUT_KEYS.forEach((k) => { t[k] = ''; });
  return t;
}

let _branding = {
  companyName: DEFAULT_COMPANY_NAME,
  logoDataUrl: '',
  footerLine: '',
  documentReference: '',
  pdfTheme: emptyPdfTheme(),
};

export function getBranding() {
  return _branding;
}

export function setBranding(next) {
  if (!next || typeof next !== 'object') return _branding;
  const incomingTheme = next.pdf_theme || next.pdfTheme;
  let pdfTheme = _branding.pdfTheme;
  if (incomingTheme && typeof incomingTheme === 'object') {
    pdfTheme = { ...emptyPdfTheme() };
    PDF_THEME_SLOTS.forEach((slot) => {
      pdfTheme[slot] = (incomingTheme[slot] || '').trim();
    });
    PDF_THEME_LAYOUT_KEYS.forEach((key) => {
      if (incomingTheme[key] !== undefined) pdfTheme[key] = incomingTheme[key];
    });
  }
  _branding = {
    companyName: next.company_name || next.companyName || _branding.companyName || DEFAULT_COMPANY_NAME,
    logoDataUrl: next.logo_data_url !== undefined ? (next.logo_data_url || '')
      : (next.logoDataUrl !== undefined ? (next.logoDataUrl || '') : _branding.logoDataUrl),
    footerLine: next.footer_line !== undefined ? (next.footer_line || '')
      : (next.footerLine !== undefined ? (next.footerLine || '') : _branding.footerLine),
    documentReference: next.document_reference !== undefined ? (next.document_reference || '')
      : (next.documentReference !== undefined ? (next.documentReference || '') : _branding.documentReference),
    pdfTheme,
  };
  return _branding;
}
